<template>
  <page>
    <v-container fluid grid-list-lg>
      <v-card>
        <v-card-text>
          <v-layout row wrap>
            <v-flex xs3>
              <v-autocomplete
                :items="acctTypeList"
                :label="treatyRILabel.riType"
                v-model="treatyRI.riType"
                item-text="label"
                item-value="value"
                data-vv-name="riType"
                :data-vv-as="treatyRILabel.riType"
                :error-messages="errors.collect('riType')"
                v-validate="'entry'"
                disabled
              ></v-autocomplete>
            </v-flex>
            <v-flex xs6>
              <v-text-field
                :label="treatyRILabel.ttyNo"
                v-model="treatyRI.ttyNo"
                item-text="label"
                item-value="value"
                data-vv-name="ttyNo"
                :data-vv-as="treatyRILabel.ttyNo"
                :error-messages="errors.collect('ttyNo')"
                v-validate="'entry'"
                readonly
              ></v-text-field>
            </v-flex>
            <v-flex xs3>
              <v-text-field
                :label="treatyRILabel.uwYr"
                v-model="treatyRI.uwYr"
                item-text="label"
                item-value="value"
                data-vv-name="uwYr"
                :data-vv-as="treatyRILabel.uwYr"
                :error-messages="errors.collect('uwYr')"
                v-validate="'entry'"
                readonly
              ></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-layout row wrap>
          <v-flex xs12>
            <v-card-title>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
              <v-spacer></v-spacer>
              <v-btn color="primary" dark class=" mr-2" @click="doNew">
                {{ treatyRILabel.newButton }}
                <v-icon right>mdi-plus</v-icon>
              </v-btn>
              <v-flex xs12>
                <message :messages="messages"></message>
              </v-flex>
            </v-card-title>
            <v-flex xs12>
              <v-data-table
                :headers="headers"
                :items="items"
                :search="search"
                :footer-props="{'items-per-page-options': itemsPerPage }"
                v-bind:options.sync="pagination"
                item-key="name"
                :loading="loading"
                :no-data-text="noDataText"
                :custom-filter="customSearch"
              >
                <template v-slot:item="row"
                  ><tr>
                    <td class="text-xs-left">{{ row.item.riType }}</td>
                    <td class="text-xs-left">{{ row.item.ttyNo }}</td>
                    <td class="text-xs-left">{{ row.item.uwYr }}</td>
                    <td class="text-xs-left">{{ row.item.riRef }}</td>
                    <td class="text-xs-left">{{ row.item.brkRef }}</td>
                    <td class="text-xs-left">{{ row.item.participation }}</td>
                    <td class="table-action-header">
                      <table-action
                        :rowData="row"
                        query
                        @query="doQuery(row.item)"
                        review
                        @review="doReview(row.item)"
                        remove
                        @remove="doPromptRemove(row.item)"
                      ></table-action>
                    </td></tr
                ></template>
              </v-data-table>
            </v-flex>
          </v-flex>
        </v-layout>
        <!-- <v-toolbar dense color="grey lighten-3" flat>
          <v-btn text icon color="green">
            <v-icon @click="$router.go(-1)">mdi-keyboard-backspace</v-icon>
          </v-btn>
          <v-icon v-if="newMode">mdi-plus</v-icon>
          <v-icon v-else>mdi-pencil</v-icon>
          <v-toolbar-title v-if="newMode">Create Treaty Reinsurer</v-toolbar-title>
          <v-toolbar-title v-else>Edit Treaty Reinsurer</v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-flex xs12 class="mt-3">
            <message :messages="messages"></message>
          </v-flex>
          <v-layout row wrap>
            <v-flex xs3>
              <v-autocomplete :items="acctTypeList" :label="treatyRILabel.riType" v-model="treatyRI.riType" item-text="label" item-value="value" data-vv-name="riType" :data-vv-as="treatyRILabel.riType" :error-messages="errors.collect('riType')" v-validate="'entry'" disabled></v-autocomplete>
            </v-flex>
            <v-flex xs6>
              <v-text-field :label="treatyRILabel.ttyNo" v-model="treatyRI.ttyNo" item-text="label" item-value="value" data-vv-name="ttyNo" :data-vv-as="treatyRILabel.ttyNo" :error-messages="errors.collect('ttyNo')" v-validate="'entry'" readonly></v-text-field>
            </v-flex>
            <v-flex xs3>
              <v-text-field :label="treatyRILabel.uwYr" v-model="treatyRI.uwYr" item-text="label" item-value="value" data-vv-name="uwYr" :data-vv-as="treatyRILabel.uwYr" :error-messages="errors.collect('uwYr')" v-validate="'entry'" readonly></v-text-field>
            </v-flex>
            <v-flex xs3>
              <v-autocomplete :items="cedTypeList" :label="treatyRILabel.brkCedRIAcct" v-model="treatyRI.brkCedRIAcct" item-text="label" item-value="value" data-vv-name="brkCedRIAcct" :data-vv-as="treatyRILabel.brkCedRIAcct" :error-messages="errors.collect('brkCedRIAcct')" v-validate="'entry'" @change="doBrkCedRIAcct"></v-autocomplete>
            </v-flex>
            <v-flex xs6>
              <v-autocomplete :items="riRefList" :label="treatyRILabel.riRef" v-model="treatyRI.riRef" item-text="label" item-value="value" :error-messages="errors.collect('ttyDetForm.riRef')" data-vv-name="ttyDetForm.riRef" :data-vv-as="treatyRILabel.riRef" v-validate="'entry'" @change="getAcctNoSfx" clearable :disabled="this.treatyRI.brkCedRIAcct === 'B'">
                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                  <v-icon color="info" @click="getHelpList('riRef')" v-text="'mdi-magnify'"></v-icon>
                </v-slide-x-reverse-transition>
              </v-autocomplete>
            </v-flex>
            <v-flex xs3>
              <v-text-field :label="treatyRILabel.acctNoSfx" v-model="treatyRI.acctNoSfx" item-text="label" item-value="value" data-vv-name="acctNoSfx" :data-vv-as="treatyRILabel.acctNoSfx" :error-messages="errors.collect('acctNoSfx')" v-validate="'entry'" readonly :disabled="this.treatyRI.brkCedRIAcct === 'B'"></v-text-field>
            </v-flex>
            <v-flex xs3>
            </v-flex>
            <v-flex xs6>
              <v-autocomplete :items="brkRefList" :label="treatyRILabel.brkRef" v-model="treatyRI.brkRef" item-text="label" item-value="value" :error-messages="errors.collect('ttyDetForm.brkRef')" data-vv-name="ttyDetForm.brkRef" :data-vv-as="treatyRILabel.brkRef" v-validate="'entry'" @change="getBrkAcctNoSfx" clearable :disabled="this.treatyRI.brkCedRIAcct === 'I'">
                <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                  <v-icon color="info" @click="getHelpList('brkRef')" v-text="'mdi-magnify'"></v-icon>
                </v-slide-x-reverse-transition>
              </v-autocomplete>
            </v-flex>
            <v-flex xs3>
              <v-text-field :label="treatyRILabel.brkAcctNoSfx" v-model="treatyRI.brkAcctNoSfx" item-text="label" item-value="value" data-vv-name="brkAcctNoSfx" :data-vv-as="treatyRILabel.brkAcctNoSfx" :error-messages="errors.collect('brkAcctNoSfx')" v-validate="'entry'" readonly :disabled="this.treatyRI.brkCedRIAcct === 'I'"></v-text-field>
            </v-flex>
            <v-flex xs6 md4>
              <v-text-field type="number" :label="treatyRILabel.riPctShare" v-model="treatyRI.riPctShare" :error-messages="errors.collect('riPctShare')" data-vv-name="riPctShare" :data-vv-as="treatyRILabel.riPctShare" v-validate="'entry|mask_decimal:4|mask_min_value:0'"></v-text-field>
            </v-flex>
            <v-flex xs6 md4>
              <v-text-field type="number" :label="treatyRILabel.participation" v-model="treatyRI.participation" :error-messages="errors.collect('participation')" data-vv-name="participation" :data-vv-as="treatyRILabel.participation" v-validate="'entry|mask_decimal:4|mask_min_value:0'"></v-text-field>
            </v-flex>
            <v-flex xs6 md4>
              <v-text-field type="number" :label="treatyRILabel.pctNotCed" v-model="treatyRI.pctNotCed" :error-messages="errors.collect('pctNotCed')" data-vv-name="pctNotCed" :data-vv-as="treatyRILabel.pctNotCed" v-validate="'entry|mask_decimal:4|mask_min_value:0'" readonly disabled></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field :label="treatyRILabel.theirTtyRef" v-model="treatyRI.theirTtyRef" item-text="label" item-value="value" data-vv-name="theirTtyRef" :data-vv-as="treatyRILabel.theirTtyRef" :error-messages="errors.collect('theirTtyRef')" v-validate="'entry'"></v-text-field>
            </v-flex>
            <v-flex xs6>
              <v-text-field :label="treatyRILabel.panelRef" v-model="treatyRI.panelRef" item-text="label" item-value="value" data-vv-name="panelRef" :data-vv-as="treatyRILabel.panelRef" :error-messages="errors.collect('panelRef')" v-validate="'entry'"></v-text-field>
            </v-flex>
          </v-layout>
        </v-card-text>
        <v-card-actions >
          <v-btn class="white--text error" @click.prevent="doBack">
            Cancel
            <v-icon right>mdi-exit-to-app</v-icon>
          </v-btn>
          <v-btn color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
            Save
            <v-icon right>{{newMode? 'mdi-plus' : 'mdi-content-save'}}</v-icon>
          </v-btn>
        </v-card-actions> -->
      </v-card>
      <v-dialog v-model="showTreatyRIDetail" width="1280px">
        <v-card>
          <v-toolbar dense color="grey lighten-3" flat>
            <v-btn text icon color="green">
              <v-icon @click="$router.go(-1)">mdi-keyboard-backspace</v-icon>
            </v-btn>
            <v-icon v-if="newMode">mdi-plus</v-icon>
            <v-icon v-else-if="queryMode">mdi-magnify</v-icon>
            <v-icon v-else>mdi-pencil</v-icon>
            <v-toolbar-title v-if="newMode">Create Treaty Reinsurer</v-toolbar-title>
            <v-toolbar-title v-else-if="queryMode">View Treaty Reinsurer</v-toolbar-title>
            <v-toolbar-title v-else>Edit Treaty Reinsurer</v-toolbar-title>
          </v-toolbar>
          <v-card-text>
            <v-flex xs12 class="mt-3">
              <message :messages="messages"></message>
            </v-flex>
            <v-layout row wrap>
              <v-flex xs3 v-if="queryMode">
                <v-subheader class="queryLabel">{{ treatyRILabel.riType }}</v-subheader>
                <div class="queryValue" v-for="item in filterAcctTypeList" :key="item.value">{{ item.label }}</div>
              </v-flex>
              <v-flex xs3 v-else>
                <v-autocomplete
                  :items="acctTypeList"
                  :label="treatyRILabel.riType"
                  v-model="treatyRI.riType"
                  item-text="label"
                  item-value="value"
                  data-vv-name="riType"
                  :data-vv-as="treatyRILabel.riType"
                  :error-messages="errors.collect('riType')"
                  v-validate="'entry'"
                  disabled
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6 v-if="queryMode">
                <v-subheader class="queryLabel">{{ treatyRILabel.ttyNo }}</v-subheader>
                <div class="queryValue">{{ treatyRI.ttyNo }}</div>
              </v-flex>
              <v-flex xs6 v-else>
                <v-text-field
                  :label="treatyRILabel.ttyNo"
                  v-model="treatyRI.ttyNo"
                  item-text="label"
                  item-value="value"
                  data-vv-name="ttyNo"
                  :data-vv-as="treatyRILabel.ttyNo"
                  :error-messages="errors.collect('ttyNo')"
                  v-validate="'entry'"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs3 v-if="queryMode">
                <v-subheader class="queryLabel">{{ treatyRILabel.uwYr }}</v-subheader>
                <div class="queryValue">{{ treatyRI.uwYr }}</div>
              </v-flex>
              <v-flex xs3 v-else>
                <v-text-field
                  :label="treatyRILabel.uwYr"
                  v-model="treatyRI.uwYr"
                  item-text="label"
                  item-value="value"
                  data-vv-name="uwYr"
                  :data-vv-as="treatyRILabel.uwYr"
                  :error-messages="errors.collect('uwYr')"
                  v-validate="'entry'"
                  readonly
                ></v-text-field>
              </v-flex>
              <v-flex xs3>
                <v-autocomplete
                  :items="cedTypeList"
                  :label="treatyRILabel.brkCedRIAcct"
                  v-model="treatyRI.brkCedRIAcct"
                  item-text="label"
                  item-value="value"
                  data-vv-name="brkCedRIAcct"
                  :data-vv-as="treatyRILabel.brkCedRIAcct"
                  :error-messages="errors.collect('brkCedRIAcct')"
                  v-validate="'entry'"
                  @change="doBrkCedRIAcct"
                  :disabled="this.newMode === false"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :items="riRefList"
                  :label="treatyRILabel.riRef"
                  v-model="treatyRI.riRef"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('ttyDetForm.riRef')"
                  data-vv-name="ttyDetForm.riRef"
                  :data-vv-as="treatyRILabel.riRef"
                  v-validate="'entry'"
                  @change="getAcctNoSfx"
                  clearable
                  :disabled="this.treatyRI.brkCedRIAcct === 'B' || this.newMode === false"
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="getHelpList('riRef')" v-text="'mdi-magnify'"></v-icon>
                  </v-slide-x-reverse-transition>
                </v-autocomplete>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  :label="treatyRILabel.acctNoSfx"
                  v-model="treatyRI.acctNoSfx"
                  item-text="label"
                  item-value="value"
                  data-vv-name="acctNoSfx"
                  :data-vv-as="treatyRILabel.acctNoSfx"
                  :error-messages="errors.collect('acctNoSfx')"
                  v-validate="'entry'"
                  readonly
                  :disabled="this.treatyRI.brkCedRIAcct === 'B' || this.newMode === false"
                ></v-text-field>
              </v-flex>
              <v-flex xs3> </v-flex>
              <v-flex xs6>
                <v-autocomplete
                  :items="brkRefList"
                  :label="treatyRILabel.brkRef"
                  v-model="treatyRI.brkRef"
                  item-text="label"
                  item-value="value"
                  :error-messages="errors.collect('ttyDetForm.brkRef')"
                  data-vv-name="ttyDetForm.brkRef"
                  :data-vv-as="treatyRILabel.brkRef"
                  v-validate="'entry'"
                  @change="getBrkAcctNoSfx"
                  clearable
                  :disabled="this.treatyRI.brkCedRIAcct === 'I' || this.newMode === false"
                >
                  <v-slide-x-reverse-transition mode="out-in" slot="append-outer">
                    <v-icon color="info" @click="getHelpList('brkRef')" v-text="'mdi-magnify'"></v-icon>
                  </v-slide-x-reverse-transition>
                </v-autocomplete>
              </v-flex>
              <v-flex xs3>
                <v-text-field
                  :label="treatyRILabel.brkAcctNoSfx"
                  v-model="treatyRI.brkAcctNoSfx"
                  item-text="label"
                  item-value="value"
                  data-vv-name="brkAcctNoSfx"
                  :data-vv-as="treatyRILabel.brkAcctNoSfx"
                  :error-messages="errors.collect('brkAcctNoSfx')"
                  v-validate="'entry'"
                  readonly
                  :disabled="this.treatyRI.brkCedRIAcct === 'I' || this.newMode === false"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md4 v-if="queryMode">
                <v-subheader class="queryLabel">{{ treatyRILabel.riPctShare }}</v-subheader>
                <div class="queryValue">{{ treatyRI.riPctShare }}</div>
              </v-flex>
              <v-flex xs6 md4 v-else>
                <v-text-field
                  type="number"
                  :label="treatyRILabel.riPctShare"
                  v-model="treatyRI.riPctShare"
                  :error-messages="errors.collect('riPctShare')"
                  data-vv-name="riPctShare"
                  :data-vv-as="treatyRILabel.riPctShare"
                  v-validate="'entry|mask_decimal:4|mask_min_value:0'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md4 v-if="queryMode">
                <v-subheader class="queryLabel">{{ treatyRILabel.participation }}</v-subheader>
                <div class="queryValue">{{ treatyRI.participation }}</div>
              </v-flex>
              <v-flex xs6 md4 v-else>
                <v-text-field
                  type="number"
                  :label="treatyRILabel.participation"
                  v-model="treatyRI.participation"
                  :error-messages="errors.collect('participation')"
                  data-vv-name="participation"
                  :data-vv-as="treatyRILabel.participation"
                  v-validate="participationPctTotalValidation"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md4>
                <v-text-field
                  type="number"
                  :label="treatyRILabel.pctNotCed"
                  v-model="treatyRI.pctNotCed"
                  :error-messages="errors.collect('pctNotCed')"
                  data-vv-name="pctNotCed"
                  :data-vv-as="treatyRILabel.pctNotCed"
                  v-validate="'entry|mask_decimal:4|mask_min_value:0'"
                  readonly
                  disabled
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md4 v-if="queryMode">
                <v-subheader class="queryLabel">{{ treatyRILabel.theirTtyRef }}</v-subheader>
                <div class="queryValue">{{ treatyRI.theirTtyRef }}</div>
              </v-flex>
              <v-flex xs6 md4 v-else>
                <v-text-field
                  :label="treatyRILabel.theirTtyRef"
                  v-model="treatyRI.theirTtyRef"
                  item-text="label"
                  item-value="value"
                  data-vv-name="theirTtyRef"
                  :data-vv-as="treatyRILabel.theirTtyRef"
                  :error-messages="errors.collect('theirTtyRef')"
                  v-validate="'entry'"
                ></v-text-field>
              </v-flex>
              <v-flex xs6 md4 v-if="queryMode">
                <v-subheader class="queryLabel">{{ treatyRILabel.panelRef }}</v-subheader>
                <div class="queryValue">{{ treatyRI.panelRef }}</div>
              </v-flex>
              <v-flex xs6 md4 v-else>
                <v-text-field
                  :label="treatyRILabel.panelRef"
                  v-model="treatyRI.panelRef"
                  item-text="label"
                  item-value="value"
                  data-vv-name="panelRef"
                  :data-vv-as="treatyRILabel.panelRef"
                  :error-messages="errors.collect('panelRef')"
                  v-validate="'entry'"
                ></v-text-field>
              </v-flex>
            </v-layout>
          </v-card-text>
          <v-card-actions>
            <v-btn class="white--text error" @click.prevent="doBack">
              Cancel
              <v-icon right>mdi-exit-to-app</v-icon>
            </v-btn>
            <v-btn v-if="queryMode === false" color="primary" type="submit" :loading="submitting" @click.prevent="doSave">
              Save
              <v-icon right>{{ newMode ? 'mdi-plus' : 'mdi-content-save' }}</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="helplist" width="900px" persistent>
        <riRef-help-list v-if="riRefHelplist" @close="doClose" @selectInterByCedRI="doAssignRiRef($event)"></riRef-help-list>
        <brkRef-help-list v-if="brkRefHelplist" @close="doClose" @selectInterByCedRI="doAssignRiRef($event)"></brkRef-help-list>
      </v-dialog>
      <!-- <v-dialog v-model="showInterHelpList" width="1280px" >
        <intermediary-help-list @close="showInterHelpList = false" :param="group" @assign-intermediary-data="assignIntermediary"></intermediary-help-list>
      </v-dialog> -->
    </v-container>
    <confirm v-model="promptRemove" @ok="doRemove"> Are you sure to delete the selected Treaty Reinsurer - {{ deleteTreatyRI }} </confirm>
  </page>
</template>

<script>
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { commonAjaxMixin } from '@/mixins/common/commonAjaxMixin'
import { acctType, cedType } from '@/const/params'
import RIRefHelplist from './helplist/RIRefHelplist'
import BrkRefHelplist from './helplist/BrkRefHelplist'
// import IntermediaryHelpList from '@/components/core/common/dialog/IntermediaryHelpList'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      newMode: true,
      reviewMode: false,
      queryMode: false,
      loading: false,
      submitting: false,
      promptRemove: false,
      helplist: false,
      riRefHelplist: false,
      brkRefHelplist: false,
      showInterHelpList: false,
      showTreatyRIDetail: false,
      selectedTreatyRI: undefined,
      deleteTreatyRI: '',
      resultStatus: undefined,
      participationAvai: 100,
      mode: '',
      headers: [
        { text: 'RI Type', value: 'riType' },
        { text: 'Treaty No.', value: 'ttyNo' },
        { text: 'Underwriting Year', value: 'uwYr' },
        { text: 'Reinsurer Reference', value: 'riRef' },
        { text: 'Broker Reference', value: 'brkRef' },
        { text: 'Participation %', value: 'participation' },
        TableConst.tableActionHeader
      ],
      treatyRILabel: {
        riType: 'Inwards / Outwards',
        propNProp: 'Proportional or Non-Proportional',
        ttyNo: 'Treaty Reference',
        uwYr: 'Underwriting Year',
        brkCedRIAcct: 'Reinsurer or Broker Account',
        riRef: 'Reinsurer Reference',
        acctNoSfx: 'Account No. Suffix',
        brkRef: 'Broker Reference',
        brkAcctNoSfx: 'Broker Account No. Suffix',
        riPctShare: 'Share % of Reinsurer',
        participation: 'Participation %',
        pctNotCed: '% Not Ceded Out',
        theirTtyRef: 'Their Treaty Reference',
        panelRef: 'Panel Reference',
        newButton: 'New Treaty Reinsurer'
      },
      treatyRI: {
        riType: undefined,
        propNProp: undefined,
        ttyNo: undefined,
        uwYr: undefined,
        brkCedRIAcct: 'I',
        riRef: undefined,
        acctNoSfx: '',
        brkRef: undefined,
        brkAcctNoSfx: '',
        riPctShare: 0,
        oriParticipation: 0,
        participation: 0,
        pctNotCed: 0,
        theirTtyRef: undefined,
        panelRef: undefined
      },
      intermediaries: [],
      riRefList: [],
      brkRefList: [],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  methods: {
    async doInit() {
      await Promise.all([this.$store.dispatch('commonsInit')])
      this.getCommonDataList('intermediaries')
      this.getRIRefList()
      this.getBrkRefList()
      this.treatyRI.riType = this.riType
      this.treatyRI.ttyNo = this.ttyNo
      this.treatyRI.uwYr = this.uwYr
      this.treatyRIList()
      this.getTreatyRIPctNotCed()
    },
    async treatyRIList() {
      this.resetMessages()
      const apiURI = this.treatyMenu.treatyRIList
      if (apiURI) {
        try {
          this.loading = true
          let expand = {
            riType: this.treatyRI.riType,
            ttyNo: this.treatyRI.ttyNo,
            uwYr: this.treatyRI.uwYr
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          if (result) {
            this.items = []
            const { data } = result.data
            data.map((result) => {
              const convertList = {
                riType: result.riType,
                ttyNo: result.ttyNo,
                uwYr: result.uwYr,
                brkCedRIAcct: result.brkCedRIAcct,
                riRef: result.riRef,
                brkRef: result.brkRef,
                acctNoSfx: result.acctNoSfx,
                brkAcctNoSfx: result.brkAcctNoSfx,
                riPctShare: result.riPctShare,
                participation: result.participation,
                theirTtyRef: result.theirTtyRef,
                panelRef: result.panelRef
              }
              this.items.push(convertList)
            })
          }
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
      this.loading = false
    },
    getHelpList(fieldname) {
      this.helplist = true
      if (fieldname === 'riRef') {
        this.riRefHelplist = true
      } else if (fieldname === 'brkRef') {
        this.brkRefHelplist = true
      }
    },
    async getRIRefList() {
      const apiURI = this.treatyMenu.initInterRIInCedRI
      if (apiURI) {
        this.loading = true
        try {
          this.loading = true
          const result = await this.$http.get(apiURI)
          if (result) {
            this.riRefList = []
            const { data } = result.data
            if (data) {
              this.riRefList = data
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getBrkRefList() {
      const apiURI = this.treatyMenu.initInterBrkInCedRI
      if (apiURI) {
        this.loading = true
        try {
          this.loading = true
          const result = await this.$http.get(apiURI)
          if (result) {
            this.brkRefList = []
            const { data } = result.data
            if (data) {
              this.brkRefList = data
            }
          }
          this.loading = false
        } catch (err) {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getAcctNoSfx() {
      const apiURI = this.treatyMenu.getAcctNoSfxByRITypeInter
      if (apiURI) {
        try {
          const expand = {
            riType: this.treatyRI.riType,
            riRef: this.treatyRI.riRef,
            brkCedRIAcct: this.treatyRI.brkCedRIAcct
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result
          if (data) {
            this.treatyRI.acctNoSfx = data.acctNoSfx
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async getBrkAcctNoSfx() {
      const apiURI = this.treatyMenu.getAcctNoSfxByRITypeInter
      if (apiURI) {
        try {
          const expand = {
            riType: this.treatyRI.riType,
            riRef: this.treatyRI.brkRef,
            brkCedRIAcct: this.treatyRI.brkCedRIAcct
          }
          const result = await this.$http.get(expandURI(apiURI, expand))
          const { data } = result
          if (data) {
            this.treatyRI.brkAcctNoSfx = data.acctNoSfx
          }
        } catch (err) {
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    getTreatyRIPctNotCed() {
      const apiURI = this.treatyMenu.getTreatyRIPctNotCed
      if (apiURI) {
        const expand = {
          riType: this.treatyRI.riType,
          ttyNo: this.ttyNo,
          uwYr: this.treatyRI.uwYr
        }
        this.$http.get(expandURI(apiURI, expand)).then((result) => {
          const { data } = result
          if (data) {
            this.treatyRI.pctNotCed = data.pctNotCed
          }
        })
      }
    },
    doAssignRiRef(interRIObj) {
      this.treatyRI.riRef = interRIObj.inter
      this.treatyRI.name = interRIObj.name
    },
    doBrkCedRIAcct() {
      if (this.treatyRI.brkCedRIAcct === 'I') {
        this.treatyRI.brkRef = undefined
        this.treatyRI.brkAcctNoSfx = undefined
      } else {
        this.treatyRI.riRef = undefined
        this.treatyRI.acctNoSfx = undefined
      }
    },
    doReview(data) {
      this.participationAvai = 100
      this.mode = 'review'
      this.showTreatyRIDetail = true
      this.newMode = false
      this.queryMode = false
      this.treatyRI.brkCedRIAcct = data.brkCedRIAcct
      this.treatyRI.riRef = data.riRef
      this.treatyRI.brkRef = data.brkRef
      this.treatyRI.acctNoSfx = data.acctNoSfx
      this.treatyRI.brkAcctNoSfx = data.brkAcctNoSfx
      this.treatyRI.riPctShare = data.riPctShare
      this.treatyRI.oriParticipation = data.participation
      this.treatyRI.participation = data.participation
      this.treatyRI.theirTtyRef = data.theirTtyRef
      this.treatyRI.panelRef = data.panelRef
      this.checkParticipationPct()
    },
    doQuery(data) {
      this.showTreatyRIDetail = true
      this.newMode = false
      this.queryMode = true
      this.treatyRI.brkCedRIAcct = data.brkCedRIAcct
      this.treatyRI.riRef = data.riRef
      this.treatyRI.brkRef = data.brkRef
      this.treatyRI.acctNoSfx = data.acctNoSfx
      this.treatyRI.brkAcctNoSfx = data.brkAcctNoSfx
      this.treatyRI.riPctShare = data.riPctShare
      this.treatyRI.participation = data.participation
      this.treatyRI.theirTtyRef = data.theirTtyRef
      this.treatyRI.panelRef = data.panelRef
    },
    doNew() {
      this.participationAvai = 100
      this.mode = ''
      this.newMode = true
      this.queryMode = false
      this.showTreatyRIDetail = true
      this.treatyRI.brkCedRIAcct = 'I'
      this.treatyRI.riRef = undefined
      this.treatyRI.brkRef = undefined
      this.treatyRI.acctNoSfx = ''
      this.treatyRI.brkAcctNoSfx = ''
      this.treatyRI.riPctShare = 0
      this.treatyRI.oriParticipation = 0
      this.treatyRI.participation = 0
      this.treatyRI.theirTtyRef = undefined
      this.treatyRI.panelRef = undefined
    },
    doBack() {
      this.participationAvai = 100
      this.mode = ''
      this.showTreatyRIDetail = false
      this.newMode = false
      this.queryMode = false
      this.treatyRI.brkCedRIAcct = 'I'
      this.treatyRI.riRef = undefined
      this.treatyRI.brkRef = undefined
      this.treatyRI.acctNoSfx = ''
      this.treatyRI.brkAcctNoSfx = ''
      this.treatyRI.riPctShare = 0
      this.treatyRI.oriParticipation = 0
      this.treatyRI.participation = 0
      this.treatyRI.theirTtyRef = undefined
      this.treatyRI.panelRef = undefined
    },
    doSave() {
      this.checkParticipationPct().then((result1) => {
        if (this.resultStatus) {
          this.resetMessages()
          this.$validator.validateAll().then((result) => {
            if (result) {
              if (this.newMode) {
                this.doCreate()
              } else {
                this.doUpdate()
              }
            } else {
              this.promptFieldCheck()
            }
          })
        }
      })
    },
    async doCreate() {
      const apiURI = this.treatyMenu.createTreatyRI
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.post(apiURI, this.treatyRI)
          const { data } = result
          if (data) {
            this.notify(data)
          }
          this.submitting = false
          this.doInit()
          this.showTreatyRIDetail = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    async doUpdate() {
      const apiURI = this.treatyMenu.updateTreatyRI
      if (apiURI) {
        this.submitting = true
        try {
          const result = await this.$http.put(apiURI, this.treatyRI)
          const { data } = result
          if (data) {
            this.notify(data)
          }
          this.submitting = false
          this.doInit()
          this.showTreatyRIDetail = false
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      }
    },
    doPromptRemove(data) {
      if (data) {
        this.promptRemove = true
        this.selectedTreatyRI = data
        this.deleteTreatyRI = data.riRef + data.brkRef
      }
    },
    doRemove() {
      const apiURI = this.treatyMenu.deleteTreatyRI
      if (apiURI) {
        const expand = this.selectedTreatyRI
        this.$http
          .post(apiURI, expand)
          .then((result) => {
            const data = result.data
            this.notify(data)
            this.promptRemove = false
            this.doInit()
          })
          .catch((err) => {
            this.promptRemove = false
            const { data } = err.response
            if (data) {
              this.message(data)
            }
          })
      }
    },
    doClose() {
      this.resetMessages()
      this.helplist = false
      setTimeout(() => {
        this.riRefHelplist = false
        this.brkRefHelplist = false
      }, 500)
    },
    async checkParticipationPct() {
      const apiUrl = this.treatyMenu.checkParticipationPct
      if (apiUrl) {
        try {
          const expand = {
            riType: this.treatyRI.riType,
            ttyNo: this.treatyRI.ttyNo,
            uwYr: this.treatyRI.uwYr,
            participation: this.treatyRI.participation,
            riRef: this.treatyRI.riRef,
            brkRef: this.treatyRI.brkRef,
            acctNoSfx: this.treatyRI.acctNoSfx,
            brkAcctNoSfx: this.treatyRI.brkAcctNoSfx,
            mode: this.mode
          }
          const result = await this.$http.get(expandURI(apiUrl, expand))
          if (result) {
            this.resultStatus = result.data.resultStatus
            this.participationAvai = result.data.participationAvai
          }
        } catch (err) {
          this.submitting = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        }
      } else {
        this.errorMessage('The request failed because it is trying to execute an invalid API url.')
      }
    }
  },
  computed: {
    treatyMenu() {
      return this.$store.state.treatyParam.menu
    },
    filterAcctTypeList() {
      return this.acctTypeList.filter((list) => {
        return list.value === this.treatyRI.riType
      })
    },
    acctTypeList() {
      let result = []
      Object.keys(acctType).forEach(function (key) {
        const status = acctType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    cedTypeList() {
      let result = []
      Object.keys(cedType).forEach(function (key) {
        const status = cedType[key]
        result.push({
          label: status,
          value: key
        })
      })
      return result
    },
    participationPctTotalValidation() {
      return 'mask_decimal:4|mask_min_value:0.0000|mask_max_value:100|participationPctTotal:' + this.participationAvai
    }
  },
  created() {
    this.doInit()
    this.$validator.extend('participationPctTotal', {
      getMessage(field, args) {
        return 'Total Participation is more than 100%, must be less than ' + args[0] + '%'
      },
      validate(value, args) {
        let riSIPctAvai = args[0]
        // console.log('riSIPctAvai = ' + riSIPctAvai)
        // console.log(value)
        if (value !== null && value > Number(riSIPctAvai)) {
          // console.log('RISIPct > riSIPctAvai false')
          return false
        } else {
          // console.log('RISIPct < riSIPctAvai true')
          return true
        }
      }
    })
  },
  props: ['riType', 'ttyNo', 'uwYr'],
  mixins: [TableConst.default, MessageMixin, commonAjaxMixin],
  components: {
    'riRef-help-list': RIRefHelplist,
    'brkRef-help-list': BrkRefHelplist
    // IntermediaryHelpList
  }
}
</script>
